import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import GradientBox from "../../components/patterns/color/GradientBox";

/**
 * MagazineFooterBannerCard
 * All Collections 영역에서 풀폭(남은 4칸)일 때 배치되는 배너 카드
 * MagazineFooterBanner 디자인을 그대로 적용
 * @param {object} props
 * @param {boolean} [props.isMobile]
 */
const MagazineFooterBannerCard = ({ isMobile, nextIssue, nextTitle }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <GradientBox
      palette={["#1A252F", "#3F4B56"]}
      type="linear"
      contrast="ambient"
      noise={true}
      noiseColor="#000000"
      noiseType="medium"
      angle={135}
      animated={true}
      animationDuration={10}
      sx={{
        width: "100%",
        pt: isMobile ? 3 : 4,
        pb: isMobile ? 4 : 6,
        px: isMobile ? 2 : 4,
        textAlign: "center",
        borderRadius: isMobile ? 4 : 8,
        backgroundColor: 'transparent',
        boxShadow: 'none',
      }}
    >
      <Stack
        spacing={isMobile ? 2 : 3}
        alignItems="center"
        sx={{ maxWidth: 600, mx: "auto" }}
      >
        <Typography
          variant={isMobile ? "h6" : "h4"}
          sx={{
            fontFamily:
              '"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif',
            fontWeight: 900,
            color: theme.palette.text.primary,
            wordBreak: "keep-all",
          }}
        >
          {nextTitle || `다음 ${nextIssue || "호"} 참여자를 찾습니다!`}
        </Typography>
        <Typography
          variant={isMobile ? "body2" : "body1"}
          sx={{
            color: theme.palette.text.primary,
            opacity: 0.9,
            wordBreak: "keep-all",
            lineHeight: 1.6,
          }}
        >
          {t('magazine.recruitBanner.apply', { issue: nextIssue || '다음호' })}
        </Typography>
        <Button
          variant="outlined"
          size={isMobile ? "medium" : "large"}
          href="https://discord.com/invite/JWjRJ9RYk4"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontWeight: 700,
            fontSize: isMobile ? "14px" : "16px",
            px: isMobile ? 3 : 4,
            py: isMobile ? 1 : 1.5,
          }}
        >
          디스코드로
        </Button>
      </Stack>
    </GradientBox>
  );
};

export default MagazineFooterBannerCard;


